import { render, staticRenderFns } from "./ServiceItemAgency.vue?vue&type=template&id=6b98e81f&"
import script from "./ServiceItemAgency.vue?vue&type=script&lang=js&"
export * from "./ServiceItemAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports